import React from 'react'

import { MattermostQuestion, SilkroadSelfSchedulingQuestion } from './utils/types'
import { useCompatibility } from './utils/useCompatibility'
import { AppointmentBookingBase } from './AppointmentBookingBase'
import type { AppointmentBookingFields } from './AppointmentBookingBase/types'
import { useBookingFlow } from './utils/useBookingFlow'

export type AppointmentBookingProps = AppointmentBookingFields & {
  post?: SilkroadSelfSchedulingQuestion | MattermostQuestion
  sendAnswer: (value: any, originalPost: void) => void
}

/**
 * Wrapper component for the appointment booking view, used in the chat flow.
 *
 * It takes a `post` prop and uses the `sendAnswer` callback to send the booking answer back to the chat.
 */
const AppointmentBooking = (props: AppointmentBookingProps) => {
  const flow = useBookingFlow(props.appointment_type)

  const processedProps = useCompatibility(props, flow)

  return <AppointmentBookingBase {...processedProps} />
}

export default AppointmentBooking
